import { render } from "./Onboarding.slides.vue?vue&type=template&id=3247d10c"
import script from "./Onboarding.slides.vue?vue&type=script&lang=js"
export * from "./Onboarding.slides.vue?vue&type=script&lang=js"

import "./Onboarding.slides.vue?vue&type=style&index=0&id=3247d10c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QCarouselControl from 'quasar/src/components/carousel/QCarouselControl.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QPage,QCarousel,QCarouselSlide,QCarouselControl,QBtn});
